
import { monicaMediaArray } from './monicaMedia'
import { rachelReviewerProfile, rossReviewerProfile, joeyReviewerProfile } from './monicaReviewers'
import { joeyBio, monicaBio, rossBio, rachelBio } from './monicaBios'
import { monicaDatingProfileHinge, monicaDatingProfileBumble, monicaDatingProfileTinder } from './monicaDatingProfiles'

export const monicaUser = {
  _id: 'monicaUserId',
  email: 'monica@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...rachelReviewerProfile },
    { ...rossReviewerProfile },
    { ...joeyReviewerProfile }
  ],
  media: [ ...monicaMediaArray ],
  bio: { ...monicaBio },
  datingProfiles: [
    { ...monicaDatingProfileHinge },
    { ...monicaDatingProfileBumble },
    { ...monicaDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const rachelUser = {
  _id: 'rachelUserId',
  email: 'rachel@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...rachelBio },
  datingProfiles: [],
  reviewerProfile: { ...rachelReviewerProfile },
}

export const rossUser = {
  _id: 'rossUserId',
  email: 'ross@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...rossBio },
  datingProfiles: [],
  reviewerProfile: { ...rossReviewerProfile },
}

export const joeyUser = {
  _id: 'joeyUserId',
  email: 'joey@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...joeyBio },
  datingProfiles: [],
  reviewerProfile: { ...joeyReviewerProfile },
}
